import { RDocument } from "@/components/DocumentViewCards/RDocument";
import { RouteConfig } from "vue-router";
import { REmployerCompanyDocumentsBrowse } from "./views/Browse/REmployerCompanyDocumentsBrowse";
import { RUploadDocuments } from "@/modules/Documents/Upload/RUploadDocuments";

export const REmployerCompanyDocuments: RouteConfig = {
  path: "documents",
  component: () =>
    import(
      /* webpackChunkName: "employer-company-documents" */
      "./VEmployerCompanyDocuments.vue"
    ),
  meta: {
    title: "Company",
    label: "documents",
  },
  children: [REmployerCompanyDocumentsBrowse, RDocument, RUploadDocuments],
};
